import React, { useState } from 'react';
import styled from 'styled-components';
import { FiChevronRight, FiChevronDown } from 'react-icons/fi';
import { Flex, Box } from 'rebass';

const Wrapper = styled.div`
    border-radius: 8px;
    //border: 1px solid #aaa;
    margin: 16px 0 32px 0;
    transition: border-color 250ms, color 250ms;
    color: black;
    //overflow: hidden;
    box-shadow: rgba(36, 18, 77, 0.08) 0px 0px 0px 1px;

    &.active {
        box-shadow: rgba(36, 18, 77, 0.08) 0px 0px 0px 1px, rgba(36, 18, 77, 0.1) 0px 0 24px -8px !important;
    }

    &:hover {
        box-shadow: rgba(36, 18, 77, 0.2) 0px 0px 0px 1px;
    }
`;

const El = styled.div`
    font-weight: 600;
    cursor: pointer;
    padding: 24px 32px;
    font-size: 16px;

    svg {
        vertical-align: top;
        margin: 4px 4px 0 0;
    }

    .show-hide {
        display: inline-block;
        margin: 0 0 0 8px;
        vertical-align: top;
    }
`;

function CollapsibleContentContainer(props) {
    const [show, setShow] = useState(props.show);

    return (
        <Wrapper className={show && 'active'} style={props.style}>
            <CollapsibleContentHeader
                show={show}
                title={props.title}
                end={props.end}
                onClick={() => {
                    const new_var = !show;
                    if (props.onToggle) {
                        props.onToggle(new_var);
                    }
                    setShow(new_var);
                }}
            />
            <CollapsibleContentBody show={show}>{props.children}</CollapsibleContentBody>
        </Wrapper>
    );
}

function CollapsibleContentHeader(props) {
    return (
        <El onClick={props.onClick} style={{ position: 'relative' }}>
            <Flex>
                <Box className='ellipsis'>{props.title}</Box>
                <Box><span className="show-hide">{props.show ? <FiChevronDown /> : <FiChevronRight />}</span></Box>
                <Box>{props.end}</Box>
            </Flex>
        </El>
    );
}

const CollapsibleContentBody = styled.div.attrs(props => ({
    display: props.show ? 'block' : 'none',
    borderColor: props.show ? '#eee' : 'transparent'
}))`
    display: ${props => props.display};
    border-top: 1px solid ${props => props.borderColor};
    font-size: 14px;
    background: #fff;
    padding: 32px;
`;

export { CollapsibleContentContainer, CollapsibleContentHeader, CollapsibleContentBody };
